import { Stack, Text } from '@ltvco/refresh-lib/theme';

import { ChatPageContainerStack } from '..';

import { BillingSection } from './sections/BillingSection/BillingSection';
import { LoginInformation } from './sections/LoginInformation/LoginInformation';
import { NeedAssistance } from './sections/NeedAssistance/NeedAssistance';
import { PlanUsage } from './sections/PlanUsage/PlanUsage';
import { ProfileDetails } from './sections/ProfileDetails/ProfileDetails';

export const AccountPageV2 = () => {
  return (
    <ChatPageContainerStack>
      <Stack
        spacing={3.5}
        padding={2.5}
        paddingTop={1}
        width="100%"
        maxWidth="1100px"
      >
        <Text variant="h1">Account</Text>
        <PlanUsage />
        <ProfileDetails />
        <LoginInformation />
        <BillingSection />
        <NeedAssistance />
      </Stack>
    </ChatPageContainerStack>
  );
};
